export * from "./brothers.component";
export * from "./brotherspanel.component";



// WEBPACK FOOTER //
// ./src/app/brothers/index.ts